module.exports = __webpack_public_path__ + "static/img/5.ca07a90.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/downloadImg/5.png
// module id = zgi2
// module chunks = 1